__turbopack_context__.v({
  "after": "Pricing-module__GqQ-iW__after",
  "card": "Pricing-module__GqQ-iW__card",
  "connector": "Pricing-module__GqQ-iW__connector",
  "connectors": "Pricing-module__GqQ-iW__connectors",
  "container": "Pricing-module__GqQ-iW__container",
  "cta": "Pricing-module__GqQ-iW__cta",
  "drop": "Pricing-module__GqQ-iW__drop",
  "flow": "Pricing-module__GqQ-iW__flow",
  "next": "Pricing-module__GqQ-iW__next",
  "note": "Pricing-module__GqQ-iW__note",
  "perk": "Pricing-module__GqQ-iW__perk",
  "perks": "Pricing-module__GqQ-iW__perks",
  "price": "Pricing-module__GqQ-iW__price",
  "priceAmount": "Pricing-module__GqQ-iW__priceAmount",
  "priceBlock": "Pricing-module__GqQ-iW__priceBlock",
  "priceFor": "Pricing-module__GqQ-iW__priceFor",
  "priceVat": "Pricing-module__GqQ-iW__priceVat",
  "question": "Pricing-module__GqQ-iW__question",
  "source": "Pricing-module__GqQ-iW__source",
  "trunk": "Pricing-module__GqQ-iW__trunk",
  "use": "Pricing-module__GqQ-iW__use",
  "useCell": "Pricing-module__GqQ-iW__useCell",
  "useCost": "Pricing-module__GqQ-iW__useCost",
  "useLabel": "Pricing-module__GqQ-iW__useLabel",
  "uses": "Pricing-module__GqQ-iW__uses",
  "wireFlowDown": "Pricing-module__GqQ-iW__wireFlowDown",
});
